import React from "react";
import ZohoFormEmbed from "./../components/zohoformEmbeed";

const ZohoKYCForm: React.FC = () => {
  return (
    <div>
      <ZohoFormEmbed />
    </div>
  );
};

export default ZohoKYCForm;
